import { useState } from "react";
import submit from "submit-form";
import Dropdown from "../../../../parts/dropdown";
import { formatNumber } from "../../../../utils/format-sub";

// A Stripe customer created by hand in the dashboard has a cus_... id and
// no MSB account behind it, so there's nobody to message.
export const isMsbUserId = (id) => /^[a-f0-9]{24}$/i.test(String(id || ""));

/**
 * Row actions shared by the Attention tab's member lists (failed payments,
 * scheduled to cancel). Charge now is a visible button, shown only when the
 * row has an open invoice to charge; the rest sit behind a "More" menu so a
 * row stays one line tall. "Email" copies to the clipboard until there's an
 * email integration — the menu closes on select, so "Copied" shows on the
 * menu's own label instead.
 */
const MemberRowActions = ({ member, currency, chatType, canMessage, t }) => {
  const [copied, setCopied] = useState(false);
  const options = [
    member.hostedInvoiceUrl && {
      text: t("income.attention.openInvoice"),
      value: "invoice",
    },
    member.customerEmail && {
      text: t("income.attention.copyEmail"),
      value: "email",
    },
    canMessage && { text: t("income.attention.message"), value: "message" },
  ].filter(Boolean);

  const onSelect = (value) => {
    if (value === "invoice") {
      window.open(member.hostedInvoiceUrl, "_blank", "noreferrer");
    } else if (value === "email") {
      navigator.clipboard.writeText(member.customerEmail);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } else if (value === "message") {
      submit(
        `/actions/user/check-chat-users/${member.customerId}/${chatType}`,
        { method: "POST", body: {} }
      );
    }
  };

  return (
    <div className="flex items-center justify-center gap-2">
      {member.invoiceId && (
        <button
          type="button"
          data-button-type="primary"
          className="whitespace-nowrap"
          onClick={() => {
            if (
              confirm(
                t("income.attention.chargeConfirm", {
                  amount: formatNumber(member.amountDue, currency),
                })
              )
            ) {
              submit("/actions/user/charge-invoice", {
                method: "POST",
                body: { invoiceId: member.invoiceId },
              });
            }
          }}
        >
          {t("income.attention.chargeNow")}
        </button>
      )}
      {options.length > 0 && (
        <Dropdown
          summaryText={t(
            copied ? "income.attention.copied" : "income.attention.more"
          )}
          options={options}
          onSelectFn={onSelect}
          overlay
          alignRight
        />
      )}
    </div>
  );
};

export default MemberRowActions;
